import type { AuthorizedResourceAccessMap } from '@/permissions/adapter';
import { isResourceAuthorizationEnabled } from '@/permissions/resourceGuard';

/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState:
    | {
        authorizedResourceAccess?: AuthorizedResourceAccessMap;
        currentTenantIsAdmin?: boolean;
      }
    | undefined,
) {
  if (!isResourceAuthorizationEnabled || initialState?.currentTenantIsAdmin) {
    return new Proxy(
      {},
      {
        get: (_target, key) => (typeof key === 'string' ? true : undefined),
      },
    ) as AuthorizedResourceAccessMap;
  }

  return initialState?.authorizedResourceAccess || {};
}
